import {Component} from '@angular/core';
import {LoanApplicationService} from '../loan-application.service';
import {WebsiteStatesService} from '../../../website-states.service';
import {AbstractControl, FormControl} from '@angular/forms';

@Component({
  selector: 'bb-page-one',
  templateUrl: './page-one.component.html',
  styleUrls: ['./page-one.component.scss'],
})
export class PageOneComponent {
  constructor(private loan: LoanApplicationService,
              private website: WebsiteStatesService) {
  }

  backward() {
    this.loan.backward();
  }

  forward() {
    if (this.isValid) {
      this.loan.forward();
    } else {
      this.markAllDirty(this.loan.form.get('employment_info'));
      this.markAllDirty(this.loan.form.get('personal_info'));
      this.markAllDirty(this.loan.form.get('branch'));
    }
    this.website.scrollToTop();
  }

  get isValid() {
    return this.loan.form.get('employment_info').valid &&
      this.loan.form.get('personal_info').valid &&
      this.loan.form.get('branch').valid;
  }

  markAllDirty(control: AbstractControl) {
    // Credit: https://github.com/angular/angular/issues/11774#issuecomment-264706699
    if (control.hasOwnProperty('controls')) {
      control.markAsDirty();
      const ctrl = <any>control;
      for (const inner of Object.keys(ctrl.controls)) {
        this.markAllDirty(ctrl.controls[inner] as AbstractControl);
      }
    } else {
      (<FormControl>(control)).markAsDirty();
      (<FormControl>(control)).markAsTouched();
    }
  }
}
